import React, { Component }  from 'react';
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category } from '@material-ui/icons';


class NavbarNew extends Component {
    constructor(props) {
        super(props);

        this.state = { 
            update: false, 
            showAlert: false,
            // categoryDataPrev: this.props.history.location.state.categoryData,
            // serviceDataPrev: this.props.history.location.state.categoryData.categories
        };
    }
    render (){
        const {title, goback} = this.props;
        return(
            <div>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    // marginBottom:50,
                    padding: 10,
                    // borderBottom: '1px solid #ddd'
                }}>
                    <span style={{color: '#0078ff', marginRight: 10}} 
                        onClick={goback}
                    >
                        <ArrowBack />
                    </span>
                    <p style={{
                        marginTop:10,
                        fontSize: 20,
                    }}>
                        {title}
                    </p>
                </div>
            </div>
        )
    }
}

export default NavbarNew


// WEBPACK FOOTER //
// ./src/components/NavBarNew/NavbarNew.js